import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import apiClient from '../services/apiClient';

function SSOLanding() {
  const [searchParams] = useSearchParams();
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    const state = searchParams.get('state');

    if (!token || !state) {
      setError('Ungültige SSO-Parameter');
      return;
    }

    // Validate via backend - server sets httpOnly cookie
    apiClient
      .post('/sso/entry', { token, state })
      .then(async (res) => {
        // Cookie is set by server, refresh auth state
        await checkAuth();
        navigate(res.data.redirectUrl || '/ris', { replace: true });
      })
      .catch((err) => {
        console.error('SSO error:', err);
        setError(err.response?.data?.error || 'SSO-Authentifizierung fehlgeschlagen');
      });
  }, [searchParams, checkAuth, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-warm-bg to-gray-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Authentifizierung fehlgeschlagen</h2>
          <p className="text-gray-600 mb-6">{error}</p>
          <a
            href="/login"
            className="inline-block bg-primary hover:bg-primary-dark text-white font-medium py-2 px-6 rounded-lg transition-colors"
          >
            Zur Anmeldung
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-warm-bg to-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-900">Authentifizierung...</h2>
        <p className="text-gray-600 mt-2">Bitte warten Sie einen Moment.</p>
      </div>
    </div>
  );
}

export default SSOLanding;
